import { __decorate } from "tslib";
import { FrontendFeaturePlugin, provideFeatureAddonRoutes, provideRootRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { DisplayMembershipModelActionService } from './model-actions';
import { MembershipFrontendSharedModule } from '@common/membership/frontend-shared';
import * as i0 from "@angular/core";
let MembershipFrontendAdminFeature = /*#__PURE__*/(() => {
  let MembershipFrontendAdminFeature = class MembershipFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/membership/frontend-admin","featureId":"common-membership"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Mitgliedschaften',
          routerLink: 'membership/membership',
          icon: 'id-card',
          priority: 7,
          items: [{
            label: 'Mitgliedschaften',
            routerLink: 'membership/membership'
          }, {
            label: 'Berichte',
            routerLink: 'membership/report'
          }]
        }, {
          label: 'Mitgliedschaften',
          routerLink: 'statistics/membership',
          displayInGroup: 'statistics',
          icon: 'id-card'
        }]
      });
      const adminCrudContextMatcher = [['admin', 'crud']];
      functionality.defineItemActions([{
        modelId: 'UserItem',
        displayContext: adminCrudContextMatcher,
        label: 'Mitgliedschaften zeigen',
        icon: 'id-card',
        action: item => {
          this.injector.get(DisplayMembershipModelActionService).displayMembershipsOfUser(item.id);
        }
      }, {
        modelId: 'UserItem',
        displayContext: adminCrudContextMatcher,
        label: 'Mitgliedschaft erstellen',
        icon: 'id-card',
        action: item => {
          this.injector.get(DisplayMembershipModelActionService).createMembershipForUser(item.id);
        }
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMembershipFrontendAdminFeature_BaseFactory;
        return function MembershipFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵMembershipFrontendAdminFeature_BaseFactory || (ɵMembershipFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MembershipFrontendAdminFeature)))(__ngFactoryType__ || MembershipFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MembershipFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'membership',
          loadChildren: () => import('./membership-admin.module').then(m => m.MembershipFrontendAdminModule)
        }]), provideFeatureAddonRoutes([{
          useAddonSlot: 'statistics',
          path: 'membership',
          loadChildren: () => import('./statistics/membership-statistics.module').then(m => m.MembershipStatisticsAdminModule)
        }])],
        imports: [MembershipFrontendSharedModule]
      });
    }
  };
  MembershipFrontendAdminFeature = __decorate([ClassName("MembershipFrontendAdminFeature")], MembershipFrontendAdminFeature);
  return MembershipFrontendAdminFeature;
})();
export { MembershipFrontendAdminFeature };